/** Header showcase data — from sf-react-app */
const TAB_FIGMA_TEXT_ONLY = [
  { value: 'me', label: 'Me' },
  { value: 'team', label: 'Team', badge: 2 },
  { value: 'unassigned', label: 'Unassigned' },
  { value: 'all', label: 'All' },
];

const HEADER_DEMO_VIEW_OPTIONS = [
  { value: 'list', label: 'List', icon: <i className="simple-icon-list" aria-hidden /> },
  { value: 'calendar', label: 'Calendar', icon: <i className="simple-icon-calendar" aria-hidden /> },
  { value: 'board', label: 'Board', icon: <i className="simple-icon-grid" aria-hidden /> },
];

export { TAB_FIGMA_TEXT_ONLY, HEADER_DEMO_VIEW_OPTIONS };